import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns, Token } from "~/modules/assets/types";
import { BadgeArrayCell } from "./BadgeArrayCell";
import { AssetTableRowData } from "../types";
import { Emdash } from "~/components/Punctuation";
import { uniqueValues } from "~/utils/functions/uniqueValues";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const TOKEN_STANDARD_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: CatalogReferenceDataSlugs.standards,
    tooltip: CatalogReferenceDataSlugs.standards,
    type: ColumnTypes.string,
    label: "Token Standard",
    width: 150,
    render: (item) => {
        if (item.isAsset) {
            const token_standards = uniqueValues(
                item.tokens
                    .filter(Boolean)
                    .map((token) => token.standards ?? [])
                    .flat(),
            );

            if (token_standards.length === 0) return <Emdash />;

            return <BadgeArrayCell values={token_standards} />;
        }

        const token = item as Token;
        return <BadgeArrayCell values={token.standards} />;
    },
};
